import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

@Component({
    selector: 'cui-system-404',
    templateUrl: './404.component.html',
    standalone: false
})
export class Error404Component implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.navigate(['/spas/dashboard']).then()
  }
}
